import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../stores/auth";
import { needsPhoneVerification } from "../lib/phoneVerification";

const ALLOWED_PATHS = new Set([
  "/account/verify-phone",
  "/login",
  "/register",
  "/forgot-password",
  "/reset-password",
  "/verify-email",
]);

/** Redirects signed-in customers without verified phone to the verify flow. */
export function RequirePhoneVerified({ children }: { children: JSX.Element }) {
  const { user, config, loading } = useAuth();
  const location = useLocation();

  if (loading) return null;
  if (!needsPhoneVerification(user, config)) return children;
  if (ALLOWED_PATHS.has(location.pathname)) return children;

  return (
    <Navigate
      to="/account/verify-phone"
      state={{ from: location.pathname }}
      replace
    />
  );
}
